import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=7f2e724a&scoped=true&"
import script from "./CardNews.vue?vue&type=script&lang=js&"
export * from "./CardNews.vue?vue&type=script&lang=js&"
import style0 from "./CardNews.vue?vue&type=style&index=0&id=7f2e724a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e724a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2e724a')) {
      api.createRecord('7f2e724a', component.options)
    } else {
      api.reload('7f2e724a', component.options)
    }
    module.hot.accept("./CardNews.vue?vue&type=template&id=7f2e724a&scoped=true&", function () {
      api.rerender('7f2e724a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/CardNews.vue"
export default component.exports